import checkDocument from "utils/checkDocument";
import checkInputs from "utils/checkInputs";

const validations = {
    checkCompany: function checkCompany(company) {
        const errors = {};
        if (!checkInputs.notNull(company.rucEmpresa)) {
            errors.rucEmpresa = "El RUC de la empresa es necesario."

        } else if (
            // !checkDocument.validarRucPersonaNatural(company.rucEmpresa) &&
            // !checkDocument.validarRucSociedadPrivada(company.rucEmpresa) &&
            // !checkDocument.validarRucSociedadPublica(company.rucEmpresa)
            false
        ) {
            errors.rucEmpresa = " RUC inválido."
        } else if (!checkInputs.isAlphanumeric(company.rucEmpresa)) {
            errors.rucEmpresa = 'No puede contener caracteres especiales, solo letras o números.';
        } else if (company.rucEmpresa.length > 20) {
            errors.rucEmpresa = 'No ingrese más de 20 caracteres.';
        }


        if (!checkInputs.notNull(company.razonSocial)) {
            errors.razonSocial = "La razón social es necesaria."
        } else if (!checkInputs.isAlphanumeric(company.razonSocial)) {
            errors.razonSocial = 'No puede contener caracteres especiales, solo letras o números.';
        } else if (company.razonSocial.length > 100 || company.razonSocial.length < 2) {
            errors.razonSocial = 'No ingrese entre 2 y 100 caracteres.';
        }

        if (!checkInputs.notNull(company.dvEmpresa)) {
            errors.dvEmpresa = "El dígito verificador es necesario."
        } else if (!checkInputs.isNumeric(company.dvEmpresa)) {
            errors.dvEmpresa = 'El dígito verificador solo puede contener números.';
        } else if (company.dvEmpresa.length !== 2) {
            errors.dvEmpresa = 'Ingrese dos caracteres del dígito verificador, por ejemplo 01.';
        }

        if (!checkInputs.notNull(company.correoElectronico)) {
            errors.correoElectronico = "El correo electrónico es necesario."
        } else if (!checkInputs.validationEmail(company.correoElectronico)) {
            errors.correoElectronico = "No puede contener caracteres especiales, solo: '(',')', '#', letras y números .";
        } else if (company.correoElectronico.length > 50) {
            errors.correoElectronico = 'No ingrese más de 50 caracteres.';
        }

        const regex = /^[0-9]{3,4}-[0-9]{4}$/;

        if (!checkInputs.notNull(company.telefono)) {
            errors.telefono = "El teléfono es necesario.";
        } else if (!regex.test(company.telefono)) {
            errors.telefono = "El formato del teléfono no es correcto. Ejemplo: 123-4567 o 1234-5678.";
        }

        const coordinateRegex = /^[+-]?\d{1,2}\.\d{6},-\d{2}\.\d{6}$/;

        if (!checkInputs.notNull(company.coordenadaSucursal)) {
            errors.coordenadaSucursal = "La coordenada de la sucursal es necesaria.";
        } else if (/\s/.test(company.coordenadaSucursal)) {
            errors.coordenadaSucursal = "No debe contener espacios en blanco.";
        } else if (company.coordenadaSucursal.length > 22) {
            errors.coordenadaSucursal = "No ingrese más de 22 caracteres.";
        } else if (!coordinateRegex.test(company.coordenadaSucursal)) {
            errors.coordenadaSucursal =
                "Formato inválido. Ejemplo: 8.974499,-79.534033 (6 decimales exactos).";
        }

        if (!checkInputs.notNull(company.direccionEmpresa)) {
            errors.direccionEmpresa = "La dirección es necesaria."
        } else if (!checkInputs.isAlphanumeric(company.direccionEmpresa)) {
            errors.direccionEmpresa = "No puede contener caracteres especiales, solo: '(',')', '#', letras y números .";
        } else if (company.direccionEmpresa.length > 100) {
            errors.direccionEmpresa = 'No ingrese más de 100 caracteres.';
        }



        if (checkInputs.notNull(company.numeroResolucion)) {
            if (!checkInputs.isNumeric(company.numeroResolucion)) {
                errors.numeroResolucion = 'No puede contener caracteres especiales, solo números.';
            } else if (company.numeroResolucion.length > 13) {
                errors.numeroResolucion = 'No ingrese más de 13 caracteres.';
            }
        }


        return errors;
    }
};




export default validations;